module.exports = __webpack_public_path__ + "img/forms.08518076.png";